import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { Box } from 'seagull';
import { YoutubePlayer } from '~/components/YoutubePlayer/YoutubePlayer';
import { LottiePlayer } from '../../LottiePlayer/LottiePlayer';
import giftAnimation from './gift.json';
import styles from './VideoPlayer.module.scss';
const VIDEO_ID = 'zbXQwOdZYyk';
const VIDEO_URL = "https://www.youtube.com/watch?v=".concat(VIDEO_ID);
export const VideoPlayer = (param)=>{
    let { progress, onPlay, onPause, onComplete, videoAlt, isMobile } = param;
    const [isPlaying, setIsPlaying] = useState(true);
    const [isHovering, setIsHovering] = useState(false);
    const togglePlay = useCallback(()=>{
        setIsPlaying((prev)=>!prev);
    }, []);
    const handlePlay = useCallback(()=>{
        setIsPlaying(true);
        onPlay();
    }, [
        onPlay
    ]);
    const handlePause = useCallback(()=>{
        setIsPlaying(false);
        onPause();
    }, [
        onPause
    ]);
    useEffect(()=>{
        if (progress < 100) return;
        const timer = setTimeout(onComplete, 1500);
        return ()=>clearTimeout(timer);
    }, [
        progress,
        onComplete
    ]);
    const showOverlayButton = !isPlaying || isHovering;
    return /*#__PURE__*/ _jsxs(motion.div, {
        className: clsx(styles.root, isMobile && styles.mobile),
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.4
        },
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: styles.videoWrapper,
                children: /*#__PURE__*/ _jsxs(Box, {
                    className: styles.videoContainer,
                    onMouseEnter: ()=>setIsHovering(true),
                    onMouseLeave: ()=>setIsHovering(false),
                    children: [
                        /*#__PURE__*/ _jsx(YoutubePlayer, {
                            className: styles.player,
                            url: VIDEO_URL,
                            width: "100%",
                            height: "100%",
                            playing: isPlaying,
                            controls: false,
                            onPlay: handlePlay,
                            onPause: handlePause,
                            config: {
                                playerVars: {
                                    modestbranding: 1,
                                    rel: 0,
                                    showinfo: 0,
                                    disablekb: 1,
                                    fs: 0,
                                    iv_load_policy: 3,
                                    cc_load_policy: 0,
                                    playsinline: 1
                                }
                            },
                            title: videoAlt
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            className: styles.clickBlocker,
                            onClick: togglePlay
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: clsx(styles.overlayButton, showOverlayButton && styles.visible),
                            onClick: togglePlay,
                            "aria-label": isPlaying ? 'Pause' : 'Play',
                            children: isPlaying ? /*#__PURE__*/ _jsx("span", {
                                className: styles.pauseIcon
                            }) : /*#__PURE__*/ _jsx("span", {
                                className: styles.playIcon
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(motion.div, {
                className: styles.controls,
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                transition: {
                    delay: 0.3,
                    duration: 0.4
                },
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.progressTrack,
                        children: /*#__PURE__*/ _jsx(Box, {
                            className: styles.progressFill,
                            style: {
                                width: "".concat(progress, "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.giftIcon,
                        children: /*#__PURE__*/ _jsx(LottiePlayer, {
                            animationData: giftAnimation,
                            autoplay: progress >= 100,
                            loop: false
                        })
                    })
                ]
            })
        ]
    }, "playing");
};
